var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56319 5.58378V10.8724C1.6413 11.8833 1.71865 13.2058 1.79676 14.1393C1.87411 15.2283 2.80761 16.0837 3.89734 16.0837H9.65233C10.7413 16.0837 11.674 15.2283 11.7529 14.1393C11.8303 13.2065 11.9076 11.884 11.9857 10.8724C12.0631 9.70608 11.9857 7.29458 11.9857 5.58378H1.56319ZM12.2193 3.25038H10.2742L9.65233 2.08331C9.26331 1.38337 8.56336 0.916992 7.78531 0.916992H5.91906C5.14101 0.916992 4.36296 1.38337 4.05204 2.08331L3.27475 3.25038H1.32962C1.01871 3.25038 0.707031 3.5613 0.707031 3.87222C0.707031 4.18313 1.01795 4.49481 1.32886 4.49481H12.2185C12.5294 4.49481 12.8404 4.26124 12.8404 3.87298C12.8404 3.48471 12.5302 3.25038 12.2193 3.25038ZM4.59652 3.25038L4.98555 2.62855C5.14101 2.31763 5.45192 2.08331 5.84095 2.08331H7.70796C8.09699 2.08331 8.40791 2.23953 8.56336 2.62779L8.95239 3.24963L4.59652 3.25038Z",
    fill: "#E00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.30f17da58699fea956a935493dc4ae8f.svg";
export { ForwardRef as ReactComponent };